function initNetisecMega(root) {
  if (root.dataset.nsMegaReady === 'true') return;
  root.dataset.nsMegaReady = 'true';
  const tabs = [...root.querySelectorAll('.ns-mega__tab')];
  const panels = [...root.querySelectorAll('.ns-mega__panel')];
  if (!tabs.length || tabs.length !== panels.length) return;

  const select = (index, moveFocus = false) => {
    tabs.forEach((tab, position) => {
      const active = position === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      panels[position].hidden = !active;
    });
    root.querySelector('.ns-mega__content')?.scrollTo({ top: 0 });
    if (moveFocus) tabs[index].focus();
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(index));
    tab.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse') select(index);
    });
    tab.addEventListener('keydown', (event) => {
      let next = index;
      if (event.key === 'ArrowDown') next = (index + 1) % tabs.length;
      else if (event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;
      event.preventDefault();
      select(next, true);
    });
  });
  select(0);
}

function initAllNetisecMegas() {
  document.querySelectorAll('[data-ns-mega]').forEach(initNetisecMega);
}

initAllNetisecMegas();
document.addEventListener('shopify:section:load', initAllNetisecMegas);
